import { useOrdersStore, useUIStore } from '../../../../store';
import { useMainHomeLogic } from '../../../../hooks/useMainHomeLogic';
import { MainPlates } from '../../cards/MainPlates';
import { MenuPlates } from '../../cards/MenuPlates';
import { PlateModal } from "../../modals/PlateModal";
import { Cart } from '../Cart';
import { TotalCart } from '../TotalCart';
import styles from './MainHome.module.scss';
import { CarrouselCategories } from '../../cards/CarrouselCategories';
import { ContentCarousel } from '../../cards/ContentCarrousel';

export const MainHome = () => {
  const {
    menuData,
    patchedMenuData,
    orders,
    total,
    plateToShow,
    cartItemToEdit,
    handleCloseModal,
    isModalVisible,
    section,
  } = useMainHomeLogic();

  const showSearch = useUIStore((s) => s.showSearch);
  const canUseCart = useOrdersStore((s) => s.canUseCart);

  const isHome = section === "home";
  const isCart = section === "cart";
  const isModal = section === "productModal";

  return (
    <>
      <div className={styles.mainContainer}>
        <div className={styles.contentColumn}>
          {isHome && (
            <>
              <ContentCarousel />
            </>
          )}

          <CarrouselCategories hidden={showSearch || !isHome} />

          <div className={showSearch ? styles.hidden : undefined}>
            <MainPlates menuData={patchedMenuData ?? menuData} />
          </div>

          <MenuPlates menuData={patchedMenuData ?? menuData} />
        </div>

        {canUseCart && (
          <aside
            className={`${styles.sidebarColumn} ${isModal || isCart ? styles.sidebarHidden : ''}`}
          >
            <div className={styles.stickyWrapper}>
              <TotalCart orders={orders} total={total} desktop />
            </div>
          </aside>
        )}
      </div>

      {canUseCart && (
        <div className={`${styles.mobileTotal} ${isModal || isCart ? styles.hidden : ''}`}>
          <TotalCart orders={orders} total={total} />
        </div>
      )}

      <div className={isHome || isCart ? undefined : styles.hidden}>
        <FooterSection />
      </div>

      <Cart orders={orders} total={total} visible={isCart} />

      <PlateModal
        plate={plateToShow}
        cartItem={cartItemToEdit}
        menuData={patchedMenuData ?? menuData}
        onClose={handleCloseModal}
        visible={isModalVisible}
      />
    </>
  );
};

const FooterSection = () => (
  <div className={styles.containerFooter}>
    <p className={styles.footer}>
      Menú digital creado por&nbsp;<strong>menugraphic.com.ar</strong>
    </p>
  </div>
);